import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as inlineEnum from '../inline-enum'

/** TODO:  */
@ngCore.Component({
  imports: [ds.input.select.single.Component, inlineEnum.Component],
  selector: 'atn-enum-input',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.dms.schema.Feature} */
  private readonly _schemaFeature = ngCore.inject(state.dms.schema.Feature)

  /**
   * @default undefined
   */
  public readonly labelSg = ngCore.input<string>(undefined, { alias: 'label' })

  /**
   * @default undefined
   * @see {@link ents.core.dms.data.Value.Type.Enum}
   */
  public readonly enumSg = ngCore.input<
    ents.core.dms.data.Value.Type.Enum | undefined
  >(undefined, {
    alias: 'enum',
  })

  /**
   * Maps {@link ents.core.dms.data.Value.Type.Enum} to
   * {@link ents.core.common.value.types.Enum.Inline}, or returns `undefined` if
   * no {@link enumSg} is provided.
   *
   * @default undefined
   * @see {@link ents.core.common.value.types.Enum.Inline}
   */
  public readonly inlineEnumSg = ngCore.computed<
    ents.core.dms.data.Value.Type.Enum.Inline | undefined
  >(
    (
      _enum = this.enumSg(),
      schema = this._schemaFeature.selectors.schema.asSignal(),
    ) =>
      // converts dms enum into common enum, if dms enum is proved, otherwise
      // default to undefined
      _enum
        ? {
            inlineEnum: schema.getCommonEnum({
              identifiable: _enum.enumId,
              isMultiselect: _enum.isMultiselect,
            }),
          }
        : undefined,
  )

  /**
   * @default undefined
   * @see {@link ents.core.dms.data.Value.Reference.Default}
   */
  public readonly valueSg = ngCore.model<unknown>(undefined, {
    alias: 'value',
  })
}
